import React, { Component } from 'react';
import classNames from 'classnames';
import { getComponentById } from '~/constants/featuresComponentsMap';
import { observer, inject } from 'mobx-react';

@inject("featuresListStore") @observer 
export default class Feature extends Component {
  constructor(props = { id, title, type, options }){
    super(props);
  }
  render() {
    let { openFeature } = this.props.featuresListStore;
    let { id, title, type, options } = this.props;
    let { isOpen } = options;
    const FeatureComponent = getComponentById(id);
    
    return (
        <div className="billy-feature">
          <div className="billy-feature__box billy-box">
            <div className={`billy-feature__header billy-bc_feature_${ type }`}>
              <i className={`billy-feature__icon fi-billy fi-billy-${ type }`} aria-hidden="true"></i>
              <span>{ title }</span>
              <button className={`billy-feature__toggle-button billy-button fi-billy fi-billy-${ isOpen ? 'minus' : 'plus' }`}
                      aria-label={`${ isOpen ? 'הסתר' : 'הצג' } חלונית`} 
                      onClick={ () => openFeature(id) }>
              </button>
            </div>
            <div className={`billy-feature__main ${ isOpen ? 'billy_active' : '' }`}>
              { FeatureComponent && <FeatureComponent featureId={ id } /> }
            </div>
          </div>
        </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Feature/index.js